<script lang="ts">
  type Props = {
    responsive?: boolean;
    children: any;
  };
  const { responsive = true, children }: Props = $props();
</script>

<!-- This is the grid that is used in Agreement.svelte that is intended to be responsive by turning from 2 column into 1 column grid on phones -->
<div class="mygrid responsive-grid" class:not-responsive-grid={!responsive}>
  {@render children()}
</div>

<style lang="postcss" scoped>
  .mygrid {
    width: 100%;
    columns: 1;
  }

  @container (min-width: 840px) {
    .responsive-grid {
      columns: 2;
    }
  }

  .not-responsive-grid {
    columns: 2;
  }
</style>
